module.exports = __webpack_public_path__ + "img/q6_sp.b1655fcc.svg";